/**
 * 
 * @author Tim
 * @date 2024-01-04
 */

import {
	url,
	appID,
	appName,
	wechatAppId,
} from "@/config.js";

process.uniEnv = {
	baseUrl: url,
	appID,
	appName,
	wechatAppId,
};